import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { useCallback, useMemo, useRef, useState, } from 'preact/compat';
import { defaultComponentConfig } from '@widgets/GiftVoucherForn/types/config';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { giftVoucherFormSchema } from '@widgets/GiftVoucherForn/validation/schema';
import FormNotices from '@widgets/shared/components/FormNotices';
import API from '@widgets/shared/API/connection';
import VoucherInput from '@widgets/shared/components/form-controls/VoucherInput';
function Form(props) {
    const formRef = useRef(null);
    const { copy, buttonText, currTotal, currExpirationDate, } = props;
    const [isRequesting, setIsRequesting] = useState(false);
    const [errorMessage, setErrorMessage] = useState(undefined);
    const [total, setTotal] = useState(currTotal);
    const [expirationDate, setExpirationDate] = useState(currExpirationDate);
    const form = useForm({
        mode: 'onChange',
        resolver: yupResolver(giftVoucherFormSchema),
        defaultValues: {
            giftVoucher: '',
        },
    });
    const handleNoticeClose = useCallback(() => {
        setErrorMessage(undefined);
    }, []);
    const { getValues, handleSubmit, setError, formState: { isValid, errors }, } = form;
    const handleSubmitForm = () => {
        setIsRequesting(true);
        setErrorMessage(undefined);
        API.addGiftVoucher(getValues('giftVoucher'))
            .then((res) => {
            if (res.success) {
                setTotal(parseFloat(res.Balance));
                setExpirationDate(res.Expires);
            }
            else {
                if (res.message) {
                    setErrorMessage(res.message);
                }
                res.errors.forEach((error) => {
                    if (error.field) {
                        setError(error.field, { message: error.message });
                    }
                });
            }
        })
            .finally(() => {
            setIsRequesting(false);
        });
    };
    return (_jsx(FormProvider, { ...form, children: _jsxs("form", { method: "POST", ref: formRef, onSubmit: handleSubmit(handleSubmitForm), noValidate: true, className: "form gift-vouchers security", children: [errorMessage && (_jsx("div", { style: { marginBottom: '1rem' }, children: _jsx(FormNotices, { message: errorMessage, type: "error", handleClose: handleNoticeClose }) })), _jsx("p", { children: copy }), _jsx(VoucherInput, { inputAttrs: {
                        id: 'gift-voucher',
                        name: 'giftVoucher',
                        type: 'text',
                    }, labelAttrs: {
                        htmlFor: 'gift-vouchers',
                        text: 'Please enter you 12 letter code:',
                        isFieldRequired: false, // it is but hiding asterix
                    } }), _jsx("div", { className: "form__actions", children: _jsx("button", { type: "submit", className: "btn", disabled: !isValid || isRequesting, children: buttonText }) }), total !== 0 && (_jsxs("div", { className: "gift-vouchers__overview", children: [_jsx("span", { className: "h4 gift-vouchers__label", children: "Gift Voucher Balance" }), _jsxs("span", { className: "h2 gift-vouchers__total", children: ["\u00A3", total.toFixed(2)] }), _jsxs("span", { className: "p gift-vouchers__expires", children: [_jsx("span", { children: "Expires: " }), _jsx("time", { dateTime: expirationDate, children: expirationDate })] })] }))] }) }));
}
function GiftVoucherForm(props) {
    const { dataset } = props;
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const formConfig = useMemo(() => ({
        ...defaultComponentConfig,
        ...formattedAttributes,
    }), [formattedAttributes]);
    return (_jsx(Form, { ...formConfig }));
}
export default GiftVoucherForm;
